import { Box, Divider, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { HeaderProps } from '../../OperacionLayout'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { InfoMensajeMobile } from '../../../components/mobile/InfoMensajeMobile'
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import { SyntheticEvent, useState } from 'react'
import { EntityWithIdAndDescriptionFields } from 'src/types'

export const HeaderMobile = ({ acciones, message }: HeaderProps) => {
    const { isNewOperacion, saveHandler, closeHandler, printHandler, actionsOptions, actionsHandler } = acciones

    const [anchorEl, setAnchorEl] = useState<Element | null>(null)

    const handleDropdownOpen = (event: SyntheticEvent) => {
        setAnchorEl(event.currentTarget)
    }

    const handleDropdownClose = (url?: string) => {
        // if (url) {
        //     navigate(url)
        // }
        setAnchorEl(null)
    }

    return (
        <>
            <InfoMensajeMobile message={message} />
            <Box display='flex'>
                <IconButton onClick={handleDropdownOpen}>
                    <MoreVertIcon color='primary' />
                </IconButton>
                {closeHandler && (
                    <IconButton onClick={closeHandler}>
                        <CloseIcon color='error' />
                    </IconButton>
                )}
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleDropdownClose()}
                sx={{ '& .MuiMenu-paper': { width: 230, mt: 4 } }}
            >
                {saveHandler && (
                    <>
                        <MenuItem>
                            <SaveIcon />
                            Guardar
                        </MenuItem>
                        <Divider />
                    </>
                )}
                {!!actionsOptions?.length && (
                    <>
                        <Divider textAlign='left'>
                            <Typography variant='caption'>Enviar a</Typography>
                        </Divider>
                        {actionsOptions.map((option, index) => (
                            <MenuItem key={index} onClick={() => actionsHandler(option)}>
                                {option[EntityWithIdAndDescriptionFields.Description]}
                            </MenuItem>
                        ))}
                        <Divider />
                    </>
                )}
                {printHandler && (
                    <>
                        <MenuItem
                            onClick={printHandler}
                            sx={{ py: 2, '& svg': { mr: 2, fontSize: '1.375rem', color: 'text.primary' } }}
                        >
                            <SaveAltIcon />
                            Generar informe
                        </MenuItem>
                    </>
                )}
            </Menu>
        </>
    )
}
